import { getEnv } from 'ecx.saigon.ui.common';
import Mock from './mock';
import apolloClient from '../../utils/apollo-client';
import { getFile as query } from '../graphql/file';

export default async function getFile(uuid) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => resolve(Mock.data[uuid]), 1000)
    );
  }

  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { uuid }
    })
  );

  return response.data.getFile;
}
